/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateEchoRespVo } from './RateEchoRespVo';
import {
    RateEchoRespVoFromJSON,
    RateEchoRespVoFromJSONTyped,
    RateEchoRespVoToJSON,
    RateEchoRespVoToJSONTyped,
} from './RateEchoRespVo';

/**
 * 
 * @export
 * @interface ResponseRateEchoRespVo
 */
export interface ResponseRateEchoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseRateEchoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseRateEchoRespVo
     */
    message?: string;
    /**
     * 
     * @type {RateEchoRespVo}
     * @memberof ResponseRateEchoRespVo
     */
    data?: RateEchoRespVo;
}

/**
 * Check if a given object implements the ResponseRateEchoRespVo interface.
 */
export function instanceOfResponseRateEchoRespVo(value: object): value is ResponseRateEchoRespVo {
    return true;
}

export function ResponseRateEchoRespVoFromJSON(json: any): ResponseRateEchoRespVo {
    return ResponseRateEchoRespVoFromJSONTyped(json, false);
}

export function ResponseRateEchoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseRateEchoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RateEchoRespVoFromJSON(json['data']),
    };
}

export function ResponseRateEchoRespVoToJSON(json: any): ResponseRateEchoRespVo {
    return ResponseRateEchoRespVoToJSONTyped(json, false);
}

export function ResponseRateEchoRespVoToJSONTyped(value?: ResponseRateEchoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': RateEchoRespVoToJSON(value['data']),
    };
}

